<mat-accordion>
  @for (accordionItem of list; track accordionItem) {
  <mat-expansion-panel class="mat-elevation-z0 rounded-0">
    <mat-expansion-panel-header [collapsedHeight]="collapsedHeight" [expandedHeight]="expandedHeight">
      <mat-panel-title>
        {{ accordionItem.header }}
      </mat-panel-title>
    </mat-expansion-panel-header>
    <p [innerHTML]="accordionItem.content"></p>
  </mat-expansion-panel>
  }
</mat-accordion>
